import FJCommunityLeftContainer from './FJCommunityLeft/FJCommunityLeftContainer.jsx';
import FJCommunityRightContainer from './FJCommunityRight/FJCommunityRightContainer.jsx';
import { useEffect } from 'react';
import FJActionCommunity from '../../redux/action/FJActionCommunity.js';
import { useDispatch, useSelector } from 'react-redux';
import FJLoading from '../../common/components/FJLoading/FJLoading.jsx';
const FJCommunity = () => {
    const dispatch = useDispatch();
    const entirePageLoading = useSelector(state => state.community.entirePageLoading);
    useEffect(() => {
        dispatch(FJActionCommunity.initUserInfoAction());
    }, [dispatch]);
    return (
        <>
            <FJCommunityLeftContainer />
            <FJCommunityRightContainer />
            {entirePageLoading && (
                <div
                    style={{
                        position: 'absolute',
                        top: 71,
                        left: 0,
                        width: '100%',
                        height: 'calc(100% - 71px)',
                        background: '#FFF',
                        zIndex: 10,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <FJLoading strokeColor='#a8acbc' style={{ width: 30, height: 30 }} />
                </div>
            )}
        </>
    );
};

export default FJCommunity;
